import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import { blueColor, primaryColor } from '../../utils/colors';
import styles from "../../assets/styles/componentStyles/apiKeyStyles/apiKeyStyle.module.scss";
import { useApiKeyStore } from '../../store/apiKeyStore';

export const getApiKeyInformationArray = () => {
    const { apikeyData } = useApiKeyStore.getState();
    
    return [
        {
            icon: <InfoOutlinedIcon />,
            title: "View Once Policy",
            description: "For your security, full API Keys are only displayed once upon creation. If you lose a key, you cannot recover it; you must generate a new one.",
            iconColor: primaryColor
        },
        {
            icon: <GppGoodOutlinedIcon />,
            title: "KEY LIMIT",
            description: (
                <span>
                    Maximum of <b>3 active keys</b>.<br />
                    <span className={styles.usageBadge}>{apikeyData?.length ?? 0} / 3 Used</span>
                </span>
            ),
            iconColor: blueColor
        }
    ]
} 